import Navbar from '../components/Navbar';
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../services/api';
import BottomNav from '../components/BottomNav';
import PublicProfile from './PublicProfile';
import PackageDetail from './PackageDetail';

export default function DriverPanel({ onBack, onTabChange, onOpenPackage }) {
  const { user, token } = useAuth();
  const [paquetes, setPaquetes] = useState([]);
  const [screen, setScreen] = useState('home');
  const [viewingUserId, setViewingUserId] = useState(null);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  const [filtroFrom, setFiltroFrom] = useState('');
  const [filtroTo, setFiltroTo] = useState('');
  const [orden, setOrden] = useState('reciente');
  const [solicitudes, setSolicitudes] = useState({});

  useEffect(() => {
    apiFetch('/packages/disponibles', {}, token)
      .then(data => setPaquetes(data))
      .catch(() => {});

    // Trae de una sola vez todas tus solicitudes activas, en vez de arrancar
    // siempre en blanco — evita que el botón parezca "olvidar" que ya ofreciste ayuda
    apiFetch('/packages/mis-solicitudes', {}, token)
      .then(misSolicitudes => {
        const estado = {};
        misSolicitudes.forEach(sol => {
          estado[sol.packageId] = sol.status;
        });
        setSolicitudes(estado);
      })
      .catch(() => {});
  }, [token]);

  const tiempoRelativo = (fecha) => {
    const ahora = new Date();
    const diff = ahora - new Date(fecha);
    const minutos = Math.floor(diff / 60000);
    const horas = Math.floor(diff / 3600000);
    const dias = Math.floor(diff / 86400000);
    if (minutos < 60) return `hace ${minutos} min`;
    if (horas < 24) return `hace ${horas}h`;
    if (dias < 7) return `hace ${dias} día${dias > 1 ? 's' : ''}`;
    return new Date(fecha).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
  };

  const handleSolicitar = async (e, packageId) => {
    e.stopPropagation();
    setSolicitudes(prev => ({ ...prev, [packageId]: 'enviando' }));
    try {
      await apiFetch(`/packages/${packageId}/solicitar`, { method: 'POST' }, token);
      setSolicitudes(prev => ({ ...prev, [packageId]: 'pendiente' }));
    } catch (err) {
      setSolicitudes(prev => ({ ...prev, [packageId]: null }));
    }
  };

  const getBtnSolicitar = (pkg) => {
    if (pkg.senderId === user?.id) return null;
    const status = solicitudes[pkg.id];
    if (status === 'enviando') return (
      <button disabled style={{backgroundColor: '#2a2d35', color: '#6b7280', fontSize: '11px', fontWeight: '600', padding: '6px 12px', borderRadius: '10px'}}>
        Enviando...
      </button>
    );
    if (status === 'pendiente') return (
      <button disabled style={{backgroundColor: '#f59e0b15', color: '#f59e0b', border: '1px solid #f59e0b30', fontSize: '11px', fontWeight: '600', padding: '6px 12px', borderRadius: '10px'}}>
        ⏳ Ofrecido
      </button>
    );
    if (status === 'aceptada') return (
      <button disabled style={{backgroundColor: '#22c55e15', color: '#22c55e', border: '1px solid #22c55e30', fontSize: '11px', fontWeight: '600', padding: '6px 12px', borderRadius: '10px'}}>
        ✅ Aceptado
      </button>
    );
    return (
      <button onClick={e => handleSolicitar(e, pkg.id)}
        style={{backgroundColor: '#f97316', color: 'white', fontSize: '11px', fontWeight: '600', padding: '6px 12px', borderRadius: '10px', cursor: 'pointer'}}>
        Ofrezco mi ayuda
      </button>
    );
  };

  const paquetesFiltrados = [...paquetes]
    .filter(pkg => {
      const matchFrom = !filtroFrom || pkg.from.toLowerCase().includes(filtroFrom.toLowerCase());
      const matchTo = !filtroTo || pkg.to.toLowerCase().includes(filtroTo.toLowerCase());
      return matchFrom && matchTo;
    })
    .sort((a, b) => {
      if (orden === 'reciente') return new Date(b.createdAt) - new Date(a.createdAt);
      if (orden === 'caro') return (b.price || 0) - (a.price || 0);
      if (orden === 'barato') return (a.price || 0) - (b.price || 0);
      return 0;
    });

  if (screen === 'publicProfile' && viewingUserId) {
    return <PublicProfile userId={viewingUserId} onBack={() => setScreen('home')} />;
  }

  if (screen === 'packageDetail' && selectedPackageId) {
    return <PackageDetail packageId={selectedPackageId} onBack={() => { setScreen('home'); setSelectedPackageId(null); }} onTabChange={onTabChange} />;
  }

  return (
    <div className="min-h-screen pb-24" style={{ backgroundColor: '#111318' }}>
      <Navbar onOpenPackage={onOpenPackage} />

      <div className="max-w-lg mx-auto px-4 pt-6">

        {/* Header */}
        <div className="mb-5">
          <p style={{color: '#f97316', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '6px'}}>
            Recogidas disponibles
          </p>
          <h1 style={{color: 'white', fontWeight: '800', fontSize: '24px', letterSpacing: '-0.02em', marginBottom: '4px'}}>
            ¿Vas de camino?
          </h1>
          <p style={{color: '#6b7280', fontSize: '13px'}}>
            Lleva algo de paso. El planeta te lo agradece 🌍
          </p>
        </div>

        {/* Filtros */}
        <div style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35', borderRadius: '16px', padding: '14px', marginBottom: '14px'}}>
          <div style={{display: 'flex', gap: '8px', marginBottom: '10px'}}>
            <input placeholder="Origen" value={filtroFrom}
              onChange={e => setFiltroFrom(e.target.value)}
              style={{flex: 1, minWidth: 0, backgroundColor: '#111318', border: '1px solid #2a2d35',
                color: 'white', borderRadius: '10px', padding: '9px 12px', fontSize: '13px', outline: 'none'}}
              className="placeholder-gray-600" />
            <input placeholder="Destino" value={filtroTo}
              onChange={e => setFiltroTo(e.target.value)}
              style={{flex: 1, minWidth: 0, backgroundColor: '#111318', border: '1px solid #2a2d35',
                color: 'white', borderRadius: '10px', padding: '9px 12px', fontSize: '13px', outline: 'none'}}
              className="placeholder-gray-600" />
          </div>
          <div style={{display: 'flex', gap: '6px'}}>
            {[
              { key: 'reciente', label: 'Reciente' },
              { key: 'caro', label: 'Más caro' },
              { key: 'barato', label: 'Más barato' },
            ].map(o => (
              <button key={o.key} onClick={() => setOrden(o.key)}
                style={{
                  flex: 1, padding: '6px', borderRadius: '8px', fontSize: '11px', fontWeight: '600', cursor: 'pointer',
                  backgroundColor: orden === o.key ? '#f97316' : '#111318',
                  color: orden === o.key ? 'white' : '#6b7280',
                  border: `1px solid ${orden === o.key ? '#f97316' : '#2a2d35'}`
                }}>
                {o.label}
              </button>
            ))}
          </div>
        </div>

        {/* Contador */}
        <p style={{color: '#3a3d45', fontSize: '11px', marginBottom: '10px'}}>
          {paquetesFiltrados.length} {paquetesFiltrados.length === 1 ? 'envío disponible' : 'envíos disponibles'}
        </p>

        {/* Sin resultados */}
        {paquetesFiltrados.length === 0 && (
          <div className="text-center py-12">
            <div className="text-4xl mb-3 opacity-20">📦</div>
            <p className="text-gray-500 text-sm">
              {filtroFrom || filtroTo ? 'No hay envíos con esa ruta' : 'No hay envíos disponibles ahora mismo'}
            </p>
            <p className="text-gray-600 text-xs mt-1">Vuelve más tarde o prueba otra ruta</p>
          </div>
        )}

        {/* Lista paquetes */}
        {paquetesFiltrados.map(pkg => (
          <div key={pkg.id}
            onClick={() => { setSelectedPackageId(pkg.id); setScreen('packageDetail'); }}
            className="rounded-2xl p-4 mb-3 cursor-pointer hover:border-orange-500 transition"
            style={{ backgroundColor: '#1a1d24', border: '1px solid #2a2d35' }}>
            <div className="flex items-start justify-between mb-2">
              <div className="flex-1 min-w-0">
                <p className="text-white font-semibold text-sm mb-0.5">{pkg.from} → {pkg.to}</p>
                {pkg.mensajePersonal ? (
                  <p className="text-gray-400 text-xs truncate italic mb-1">"{pkg.mensajePersonal}"</p>
                ) : pkg.description ? (
                  <p className="text-gray-500 text-xs truncate mb-1">{pkg.description}</p>
                ) : null}
                <p style={{ color: '#f97316' }} className="text-xs font-semibold">
                  {pkg.weight}kg · {pkg.price}€ contribución al viaje
                </p>
              </div>
            </div>
            <div className="flex items-center justify-between pt-3" style={{ borderTop: '1px solid #2a2d35' }}>
              <div className="flex items-center gap-2">
                <div onClick={e => { e.stopPropagation(); setViewingUserId(pkg.senderId); setScreen('publicProfile'); }}
                  className="flex items-center gap-2 cursor-pointer">
                  {pkg.sender?.avatar ? (
                    <img src={pkg.sender.avatar} alt="" className="rounded-full object-cover flex-shrink-0"
                      style={{ width: 30, height: 30 }} />
                  ) : (
                    <div style={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: '#f97316',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 12, fontWeight: 'bold', color: 'white', flexShrink: 0 }}>
                      {pkg.sender?.name?.charAt(0) || '?'}
                    </div>
                  )}
                  <p className="text-white text-xs font-semibold">{pkg.sender?.name || 'Anónimo'}</p>
                </div>
              </div>
              <div className="flex items-center gap-8">
                <span style={{ color: '#6b7280', fontSize: '11px' }}>
                  {tiempoRelativo(pkg.createdAt)}
                </span>
                {getBtnSolicitar(pkg)}
              </div>
            </div>
          </div>
        ))}

        <p className="text-center text-xs mt-6" style={{ color: '#2a2d35' }}>
          Cada viaje compartido es una decisión por el planeta 🌍
        </p>
      </div>

      <BottomNav active="home" onChange={onTabChange} unreadCount={0} />
    </div>
  );
}